var _rect, _line, _line2, _line3, _line4, _line5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 13,
    viewBox: "0 0 23 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 12,
    rx: 1.5,
    stroke: "#3E3D3D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 12,
    x2: 5.5,
    stroke: "#3E3D3D"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 13,
    x2: 17.5,
    stroke: "#3E3D3D"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 13,
    x2: 14.5,
    stroke: "#3E3D3D"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 13,
    x2: 11.5,
    stroke: "#3E3D3D"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 13,
    x2: 8.5,
    stroke: "#3E3D3D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.c541e78de12ae366a8843c9e8d1d2c25.svg";
export { ForwardRef as ReactComponent };